import { render, staticRenderFns } from "./DaftarKeluarga.vue?vue&type=template&id=3d446950&scoped=true"
import script from "./DaftarKeluarga.vue?vue&type=script&lang=js"
export * from "./DaftarKeluarga.vue?vue&type=script&lang=js"
import style0 from "./DaftarKeluarga.vue?vue&type=style&index=0&id=3d446950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d446950",
  null
  
)

export default component.exports